import { get } from 'lodash';
import moment from 'moment-timezone';
import noTimeZoneMoment from 'moment';
import store from '../../../../javascript/store';

export default (datetime, config = {}) => {
  if (!datetime) return '-';

  moment.locale(get(store.getState(), 'config.lang'));
  const user = get(store.getState(), 'auth.user');
  const defaultConfig = {
    withTime: false,
    format: (user && get(user, 'european') ? 'DD MMM, YYYY' : 'MMM DD, YYYY'),
    addDays: 0
  };
  const options = Object.assign({}, defaultConfig, config);

  let dateFormat = options.format;

  if (!options.withTime) {
    return noTimeZoneMoment.utc(datetime).format(dateFormat);
  }

  const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (options.withTime) dateFormat += ' hh:mm A z';

  if (!currentTimezone) return moment(datetime).add(options.addDays, 'days').format(dateFormat);

  return moment(datetime).add(options.addDays, 'days').tz(currentTimezone).format(dateFormat);
};
